<template>
	<v-app :class="{ blur: showCredits, mobile: xs }" :theme="store.theme">
		<v-navigation-drawer v-if="!smAndDown" order="2" width="200" floating location="left">
			<div class="h-100 d-flex align-center justify-center">
				<a v-if="MODE === 'production'" href="https://t.ajrkm.link/322463/9403/0?target=banners&file_id=613434&aff_sub5=SF_006OG000004lmDN&aff_sub4=AT_0002"><img src="https://www.imglnkx.com/9403/ADV-1207_DESIGN-21652_Hentai-Banners_160600.jpg" width="160" height="600" border="0" /></a>
				<v-skeleton-loader v-else height="600" width="160"></v-skeleton-loader>
			</div>
		</v-navigation-drawer>
		<nav-header v-if="routerIsReady" :theme="store.theme" @update:theme="updateTheme" :signup="signup" />
		<v-main>
			<router-view v-slot="{ Component }">
				<keep-alive>
					<component :is="Component" @update:theme="updateTheme" @error="errorHandler" @signup="signup = true" />
				</keep-alive>
			</router-view>
		</v-main>
		<v-navigation-drawer v-if="!smAndDown" order="2" width="200" floating location="right">
			<div class="h-100 d-flex align-center justify-center">
				<a v-if="MODE === 'production'" href="https://t.ajump.link/322463/9193/0?file_id=612446&aff_sub5=SF_006OG000004lmDN&aff_sub4=AT_0002"><img src="https://www.imglnkx.com/9193/intimate.ai-160x600-083024-b.png" width="96%" height="100%" border="0" /></a>
				<v-skeleton-loader v-else height="720" width="96%"></v-skeleton-loader>
			</div>
		</v-navigation-drawer>
		<nav-footer v-if="!xs || $route.path === '/'" :style="smAndDown ? '' : 'padding: 0 200px 50px 200px'" />
		<v-snackbar text :timeout="-1" v-model="snackbar.active" style="opacity: 0.95" @click="snackbarCloseHandler" :color="store.theme === 'dark' ? 'grey-lighten-4' : 'grey-darken-4'">
			<v-row>
				<v-col cols="1" class="d-flex align-center justify-center py-0">
					<v-icon :icon="snackbar.icon" :color="snackbar.iconColor" :size="smAndDown ? 'x-small' : 'x-large'" class="ml-2" />
				</v-col>
				<v-col cols="10" class="d-flex align-center justify-center py-0">
					<span v-if="snackbar.message" v-html="snackbar.message"></span>
					<span v-else @click="reload" class="font-weight-light" v-bind:class="smAndDown ? 'caption' : ''" style="cursor: pointer">App update available.</span>
				</v-col>
				<v-col cols="1" class="d-flex align-center justify-center py-0">
					<v-btn variant="plain" :size="smAndDown ? 'x-small' : 'default'" @click="snackbarCloseHandler" icon="cancel" />
				</v-col>
			</v-row>
		</v-snackbar>
	</v-app>
</template>
<style>
html,
body {
	overscroll-behavior-x: none;
	background: white;
}

.mobile video::-webkit-media-controls {
	display: none !important;
	visibility: hidden !important;
}

.sigmar-font {
	font-family: 'Sigmar', sans-serif;
	font-weight: 400;
	font-style: normal;
}

.honk-font {
	font-family: 'Honk', serif;
	font-optical-sizing: auto;
	font-weight: 400;
	font-style: normal;
	font-variation-settings: 'MORF' 15, 'SHLN' 50;
}

.honk-font.h2 {
	font-size: 10rem !important;
}

.honk-font.h4 {
	font-size: 3rem !important;
}

.honk-font.h5 {
	font-size: 2rem !important;
}

.dynapuff-font {
	font-family: 'DynaPuff', serif;
	font-optical-sizing: auto;
	font-weight: normal;
	font-style: normal;
	font-variation-settings: 'wdth' 100;
}

.danfo-font {
	font-family: 'Danfo', serif;
	font-optical-sizing: auto;
	font-weight: 400;
	font-style: normal;
	font-variation-settings: 'ELSH' 0;
	font-size: 1.2rem;
}

.grandstander-font {
	font-family: 'Grandstander', serif;
	font-optical-sizing: auto;
	font-weight: normal;
	font-style: normal;
}
</style>
<script setup>
import { ref, getCurrentInstance, provide, inject, onBeforeMount } from 'vue'
import { useAppStore } from '@/store/app'
import { useDisplay } from 'vuetify/lib/framework.mjs'
import posthog from 'posthog-js'
import * as dashjs from 'dashjs'
import 'animate.css'

import NavHeader from '@/components/nav/NavHeader.vue'
import NavFooter from './components/nav/NavFooter.vue'

const { MODE } = import.meta.env
if (MODE === 'production')
	posthog.init('phc_CgtAU0MHa7Itfb8z551yUSlHGyjvwRhcPZbeJ6POoHo', {
		api_host: 'https://us.i.posthog.com',
		person_profiles: 'always',
	})
const clipboard = inject('clipboard')
const { $api, $keycloak, $emitter } = getCurrentInstance().appContext.config.globalProperties
const { xs, smAndDown } = useDisplay()
const store = useAppStore()
const resetLocalStorage = ref(false)
const routerIsReady = ref(false)
const signup = ref(false)
const emit = defineEmits(['update:theme', 'error', 'signup'])
const error = ref(false)
const version = ref()
const snackbarDefault = {
	active: false,
	icon: 'info',
	message: undefined,
}
const snackbar = ref({ ...snackbarDefault })
const lastBuild = ref()
const showCredits = ref(false)
const versionCheckIntervalId = ref()
const buildInfo = ref()

function errorHandler(errorMessage) {
	error.value = true
	snackbar.value = {
		active: true,
		icon: 'error',
		iconColor: 'red',
		message: errorMessage,
	}
}
function snackbarCloseHandler() {
	snackbar.value.active = false
	setTimeout(() => {
		snackbar.value = { ...snackbarDefault }
		if (error.value) {
			error.value = false
		}
	}, 500)
}
function reload() {
	const url = new URL(window.location.href)
	url.searchParams.set('cache', Date.now())
	window.location.href = url.toString()
}
async function checkVersion() {
	buildInfo.value = await $api.buildInfo()

	if (!buildInfo.value?.build_date) {
		return
	}
	version.value = buildInfo.value.commit_sha
	if (lastBuild.value && lastBuild.value?.build_date !== buildInfo.value.build_date) {
		snackbar.value.active = true
		// TODO: put some extra check here...
		resetLocalStorage.value = true
	} else {
		lastBuild.value = buildInfo.value
	}
}
function cacheIsOld(timestamp = Date.now(), maxAge = store.apiCalls.maxAge) {
	const expires = timestamp + maxAge
	const isOld = !timestamp || Date.now() > expires

	const red = '\x1b[31m'
	const green = '\x1b[32m'
	const reset = '\x1b[0m'
	console.log(`cache (${isOld ? `${red}EXPIRED${reset}` : `${green}valid${reset}`}): timestamp:${new Date(timestamp).toLocaleString()}, expires: ${new Date(expires).toLocaleString()} (${(expires - Date.now()) / 1000}) secs`)
	return isOld
}
async function hashString(message, algorithm = 'SHA-1') {
	const encoder = new TextEncoder()
	const data = encoder.encode(message)
	const hashBuffer = await crypto.subtle.digest(algorithm, data)
	const hashArray = Array.from(new Uint8Array(hashBuffer))
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
	return hashHex
}
function updateTheme() {
	store.theme = store.theme === 'dark' ? 'light' : 'dark'
	emit('update:theme')
}
function debouncer(func, delay) {
	let debounceTimeout

	return (...args) => {
		if (debounceTimeout) clearTimeout(debounceTimeout)
		debounceTimeout = setTimeout(() => {
			func.apply(this, args)
		}, delay)
	}
}
function cleanPayload(data) {
	const payload = Object.fromEntries(
		Object.entries({
			...data,
		}).filter(([_key, value]) => value)
	)

	return payload
}
async function copyHandler(tooltips, tooltipName, value) {
	try {
		const copied = await clipboard.copy(value)
		if (copied && !(copied instanceof Error)) {
			tooltips[tooltipName] = true
		}
	} finally {
		setTimeout(() => {
			tooltips[tooltipName] = false
		}, 1500)
	}
}

checkVersion()
versionCheckIntervalId.value = setInterval(checkVersion, 60000)

function handleSharedFiles(title, text, url, files) {
	console.info('handleSharedFiles() ', title, text, url, files)
	if (files.length) {
		store.shared = {
			title,
			text,
			url,
			files,
		}
	}
}
navigator.serviceWorker.addEventListener('message', event => {
	if (event.data?.type === 'SHARED_FILES') {
		const { title, text, url, files } = event.data

		// Convert ArrayBuffer back to Blob for preview/upload
		const fileObjects = files.map(f => new File([new Blob([f.blob])], f.name, { type: f.type }))

		// Handle file processing (display, upload, etc.)
		handleSharedFiles(title, text, url, fileObjects)
	}
})
navigator.serviceWorker.ready.then(registration => {
	if (registration.active) {
		registration.active.postMessage('READY_FOR_SHARE')
	}
})
function scrollSectionIntoView(sectionElement) {
	setTimeout(() => {
		sectionElement.scrollIntoView({
			alignTop: true,
			behavior: 'smooth', // Smooth scroll
			block: 'start', // Align to the start of the view
		})
	})
}
function setRefs(el, refs, refStrings) {
	refStrings.forEach(refString => {
		if (!refs.value[refString]) {
			refs.value[refString] = el
		}
	})

	return refs.value[refStrings[0]]
}
function manageActiveVideoState(source, document, pauseAll = false) {
	const primaryVideos = Array.from(document.querySelectorAll(`.${source} video.primary-media`))
	const secondaryVideos = Array.from(document.querySelectorAll(`.${source} video.secondary-media`))
	const videosArr = [primaryVideos, secondaryVideos]

	if (pauseAll) {
		console.log('Pausing/muting all videos...')
	}
	videosArr.forEach(videos => {
		videos.forEach((video, index, videos) => {
			const isActive = video.closest('.swiper-slide-active')

			if (isActive && !pauseAll) {
				try {
					// only unpause secondary videos
					if (!video.classList.contains('secondary-media')) {
						video.muted = false
					}
				} catch (error) {
					console.warn(error)
					// Ignore pause errors
				}
				try {
					video.play().catch(error => {})
				} catch (error) {
					console.warn(error)
					// Ignore pause errors
				}
			} else {
				try {
					video.muted = true
				} catch (error) {
					console.warn(error)
					// Ignore pause errors
				}
				try {
					video.pause()
				} catch (error) {
					console.warn(error)
					// Ignore pause errors
				}
			}

			if (MODE !== 'production' && index === videos.length - 1) {
				console.log(
					`total paused videos (${source}: ${video.classList.contains('primary-media') ? 'primary' : 'secondary'}): ${videos.filter(video => video.paused).length}, total playing videos (${video.classList.contains('primary-media') ? 'primary' : 'secondary'}): ${videos.filter(video => !video.paused).length}`
				)
			}
		})
	})
}
function initializeDash(source, videos) {
	/*
    videos
		.filter(video => video.dash)
		.forEach(video => {
			console.log(`${video.id} is already initialized`)
		})
    */
	videos
		.filter(video => !video.dash)
		.forEach(video => {
			const player = dashjs.MediaPlayer().create()

			console.log('✅ Initializing DASH.js for (source:', source, '):', video.id, video.src)
			player.initialize(video, video.src, true)
			store.dashPlayers[video.id] = {
				player,
				timestamp: Date.now(),
			}
			video.dash = player
		})
}

;(function hackXHR() {
	const originalOpen = XMLHttpRequest.prototype.open
	window._segmentMap = {}

	XMLHttpRequest.prototype.open = function (method, url, async, user, password) {
		if (url.includes('bank.sfo3.digitaloceanspaces.com')) {
			const [_, userId, timestamp, file] = url.match(/june07\.com\/([^\/]*)\/([^\/]*)\/([^?]*)/)
			const key = Object.keys(window._segmentMap).find(key => key.includes(userId) && key.includes(timestamp) && key.includes(file))

			if (!key) {
				console.log('No key found for URL:', url)
				return originalOpen.call(this, method, url, async, user, password)
			}
			// console.log('Intercepted S3 Request:', key)

			return originalOpen.call(this, method, window._segmentMap[key] || url, async, user, password)
		}
		return originalOpen.call(this, method, url, async, user, password)
	}
})()

function setActiveDeposit(swiperMode, slides, realIndex) {
	if (!slides?.length) return

	let activeDeposit

	if (swiperMode === 'users') {
		activeDeposit = {
			userId: slides[realIndex]?.userId,
			...(slides[realIndex]?.deposits?.[0] || []), //?.topicId
		}
	} else if (swiperMode === 'user') {
		activeDeposit = slides[realIndex] || []
	}

	if (!activeDeposit) return

	store.activeDeposit = activeDeposit
	$emitter.emit('activeDeposit', activeDeposit)
}
onBeforeMount(() => {
	store.dashPlayers = {}
})

provide('setActiveDeposit', setActiveDeposit)
provide('initializeDash', initializeDash)
provide('manageActiveVideoState', manageActiveVideoState)
provide('setRefs', setRefs)
provide('scrollSectionIntoView', scrollSectionIntoView)
provide('copyHandler', copyHandler)
provide('cleanPayload', cleanPayload)
provide('debouncer', debouncer)
provide('hashString', hashString)
provide('cacheIsOld', cacheIsOld)
provide('idToken', () => $keycloak.idTokenParsed)
</script>
